import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to handle report payment logic based on order status and submission.
 * @param {Object} params
 * @param {string} params.orderStatusDescription - The order status description.
 * @param {Object} params.usageOrderSubmission - The usage order submission object.
 * @param {Function} params.setShowReportPayment - Setter for report payment visibility.
 * @param {Function} params.dispatch - Redux dispatch function.
 * @param {Function} params.fetchUsageDetailsRequest - Redux action creator for fetching usage details.
 * @param {Object} params.history - React Router history object.
 * @param {Function} params.t - Translation function.
 */
export function useReportPaymentEffect({
    orderStatusDescription,
    usageOrderSubmission,
    setShowReportPayment,
    dispatch,
    fetchUsageDetailsRequest,
    history,
    t,
}) {
    useEffectWithErrorLogging(() => {
        if (
            orderStatusDescription !== undefined &&
            usageOrderSubmission !== null &&
            usageOrderSubmission !== 'null' &&
            !(
                usageOrderSubmission &&
                usageOrderSubmission?.clickedBtn === 'submit'
            )
        ) {
            setShowReportPayment(
                orderStatusDescription ===
                    t('orders.orderStatuses.submittedPendingPriceOverride') ||
                    orderStatusDescription ===
                        t('calendar.actionPanel.awaitingPO')
                    ? true
                    : false
            );
            dispatch(
                fetchUsageDetailsRequest({
                    resourceType: 'reportPayment',
                    myCaseRef: history.location.pathname.replace(
                        '/reportUsage/',
                        ''
                    ),
                })
            );
        }
    }, [orderStatusDescription]);
}
